import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card card-default custom-card-height" }
const _hoisted_3 = { class: "card-header feature-header" }
const _hoisted_4 = { class: "row g-2" }
const _hoisted_5 = { class: "col-auto me-auto" }
const _hoisted_6 = { class: "col-auto" }
const _hoisted_7 = { class: "col-auto" }
const _hoisted_8 = { class: "col-auto" }
const _hoisted_9 = { class: "card-body p-2" }
const _hoisted_10 = { class: "card-body-grid" }
const _hoisted_11 = {
  class: "btn-group actions-row",
  role: "group",
  "aria-label": "Basic example"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  class: "modal fade",
  id: "roleModal",
  role: "dialog"
}
const _hoisted_15 = { class: "modal-dialog modal-lg modal-dialog-scrollable" }
const _hoisted_16 = { class: "modal-content" }
const _hoisted_17 = { class: "modal-header" }
const _hoisted_18 = {
  key: 0,
  class: "modal-title"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  class: "modal-title"
}
const _hoisted_21 = { class: "modal-body" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-8" }
const _hoisted_24 = { class: "input-group input-group-sm" }
const _hoisted_25 = { class: "input-group-prepend" }
const _hoisted_26 = {
  class: "input-group-text",
  id: "basic-addon1"
}
const _hoisted_27 = { class: "col-4" }
const _hoisted_28 = {
  class: "btn-group btn-group-sm",
  role: "group",
  "aria-label": "Basic example"
}
const _hoisted_29 = { class: "row mt-3" }
const _hoisted_30 = { class: "col-sm-12" }
const _hoisted_31 = { class: "modal-responsive" }
const _hoisted_32 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardTitleComponent = _resolveComponent("CardTitleComponent")!
  const _component_SearchComponent = _resolveComponent("SearchComponent")!
  const _component_SubscriptionCommonComponent = _resolveComponent("SubscriptionCommonComponent")!
  const _component_e_column = _resolveComponent("e-column")!
  const _component_e_columns = _resolveComponent("e-columns")!
  const _component_ejs_grid = _resolveComponent("ejs-grid")!
  const _component_CustomTreeView = _resolveComponent("CustomTreeView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_CardTitleComponent)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_SearchComponent, {
                modelValue: _ctx.searchText,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
                onSearch: _ctx.onSearch,
                onClear: _ctx.clearSearch
              }, null, 8, ["modelValue", "onSearch", "onClear"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.isHost())
                ? (_openBlock(), _createBlock(_component_SubscriptionCommonComponent, {
                    key: 0,
                    ref: "subscriptionComponentRef",
                    onOnSubscription: _ctx.onSubscriptionChange
                  }, null, 8, ["onOnSubscription"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("a", {
                class: _normalizeClass(["btn btn-outline-primary", { disabled: _ctx.isHost() && !_ctx.selectedSubscription?.id }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => ((!_ctx.isHost() || _ctx.selectedSubscription?.id) && _ctx.open()))
              }, [
                _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1)),
                _createTextVNode(_toDisplayString(_ctx.$t('addNew')), 1)
              ], 2)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_ejs_grid, {
              ref: "gridRole",
              dataSource: _ctx.data,
              allowPaging: true,
              allowResizing: true,
              pageSettings: _ctx.pageSettings,
              locale: _ctx.locale,
              rowHeight: 38,
              allowSorting: true,
              height: "100%",
              searchSettings: _ctx.searchOptions,
              dataStateChange: _ctx.dataStateChange,
              queryCellInfo: _ctx.queryCellInfo
            }, {
              default: _withCtx(() => [
                _createVNode(_component_e_columns, null, {
                  default: _withCtx(() => [
                    (_ctx.isHost())
                      ? (_openBlock(), _createBlock(_component_e_column, {
                          key: 0,
                          headerText: _ctx.$t('organization'),
                          field: "Subscription.OrganizationName"
                        }, null, 8, ["headerText"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('role'),
                      field: "Name"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('role') + ' ' + _ctx.$t('displayName'),
                      field: "DisplayName"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('actions'),
                      width: "75",
                      textAlign: "Center",
                      template: 'actionTemplate'
                    }, {
                      actionTemplate: _withCtx(({ data }) => [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            class: "ms-2 action-link action-edit",
                            title: "Edit",
                            onClick: ($event: any) => (_ctx.commandClick('Edit', data))
                          }, [...(_cache[10] || (_cache[10] = [
                            _createElementVNode("i", {
                              class: "e-edit e-icons",
                              style: {"font-size":"0.76em"}
                            }, null, -1)
                          ]))], 8, _hoisted_12),
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            class: "ms-2 action-link action-delete",
                            title: "Delete",
                            onClick: ($event: any) => (_ctx.commandClick('Delete', data))
                          }, [...(_cache[11] || (_cache[11] = [
                            _createElementVNode("i", {
                              class: "e-delete e-icons",
                              style: {"font-size":"0.76em"}
                            }, null, -1)
                          ]))], 8, _hoisted_13)
                        ])
                      ]),
                      _: 1
                    }, 8, ["headerText"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["dataSource", "pageSettings", "locale", "searchSettings", "dataStateChange", "queryCellInfo"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            (_ctx.isHost())
              ? (_openBlock(), _createElementBlock("h4", _hoisted_18, [
                  _createTextVNode(_toDisplayString(_ctx.$t('role')) + " ", 1),
                  (_ctx.role.organizationName)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, "- " + _toDisplayString(_ctx.role.organizationName), 1))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("h4", _hoisted_20, _toDisplayString(_ctx.$t('role')), 1)),
            _createElementVNode("button", {
              type: "button",
              class: "close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.close()))
            }, [...(_cache[12] || (_cache[12] = [
              _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("span", _hoisted_26, [
                      _createTextVNode(_toDisplayString(_ctx.$t('role') + ' ' + _ctx.$t('name')) + "  ", 1),
                      _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-red" }, "*", -1))
                    ])
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.role.displayName) = $event)),
                    "data-pi": "",
                    autocomplete: "off"
                  }, null, 512), [
                    [_vModelText, _ctx.role.displayName]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("button", {
                    class: "btn btn-default btn-sm",
                    style: {"font-size":"0.76em","font-weight":"500"},
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onExpandCollapseAll && _ctx.onExpandCollapseAll(...args)))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(_ctx.treeManage.isExpand
                    ? 'fas fa-expand me-2'
                    : 'fas fa-compress me-2'
                    )
                    }, null, 2),
                    _createTextVNode(_toDisplayString(!_ctx.treeManage.isExpand ? 'Expand All' : 'Collapse All'), 1)
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-default btn-sm",
                    style: {"font-size":"0.76em","font-weight":"500"},
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onSelectUnselectAll && _ctx.onSelectUnselectAll(...args)))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(_ctx.treeManage.isSelect
                    ? 'fas fa-check-circle me-2'
                    : 'fas fa-circle me-2'
                    )
                    }, null, 2),
                    _createTextVNode(_toDisplayString(_ctx.treeManage.isSelect ? 'Select All' : 'Unselect All'), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_CustomTreeView, {
                    ref: "treeviewPage",
                    dataSource: _ctx.rolePages,
                    fields: { id: 'id', pid: 'pid', text: 'name', hasChildren: 'hasChild' },
                    modelValue: _ctx.selectedTreeNodes,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedTreeNodes) = $event))
                  }, null, 8, ["dataSource", "modelValue"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-outline-close",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.close()))
            }, [
              _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fas fa-times" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('close')), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-outline-info-reverse",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onUpsert()))
            }, [
              _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fas fa-save" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.isUpdate ? _ctx.$t('update') : _ctx.$t('save')), 1)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}